export function toArray(data) {
  if (Array.isArray(data)) {
    return data
  } else {
    return [data]
  }
}
